module.exports = __webpack_public_path__ + "static/img/23.31e7638.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/23.png
// module id = kIk0
// module chunks = 1